import * as React from "react";
import useInputsStates from "hooks/useInputsStates";
import MenuItemDotBadge from "components/navigation/MenuItemDotBadge";
const InputsDotBadge = ({ text }) => {
  const { data, isLoading } = useInputsStates();
  if (isLoading) {
    return null;
  }
  const hasFailedOrSetupInputs = Object.values(data).some(
    (inputStateByNode) => Object.values(inputStateByNode).some((node) => ["FAILED", "FAILING", "SETUP"].includes(node.state))
  );
  return /* @__PURE__ */ React.createElement(
    MenuItemDotBadge,
    {
      text,
      title: "Some inputs are in failed state or in setup mode.",
      showDot: hasFailedOrSetupInputs
    }
  );
};
export default InputsDotBadge;
